import goPager from '../../utils/goPager';
import urlMapping from '../../utils/urlMapping';

export interface IState {
    /** 当前页面url */
    pageHash: string;
    /** iframe url */
    iframeHash: string;
}

const mainContent = {
    name: 'mainContent',
    state: {
        pageHash: '',
        iframeHash: '',
    } as IState,
    reducers: {
        setData(state: IState, payload: Partial<IState>) {
            return {
                ...state,
                ...payload,
            };
        },
        setShellHash(state: IState, payload: string) {
            const pageHash = urlMapping[payload] ? urlMapping[payload] : payload;

            return {
                ...state,
                pageHash: pageHash || state.pageHash,
            };
        },
        setFrameHash(state: IState, payload: string) {
            const targetHash = goPager(payload);
            return {
                ...state,
                iframeHash: targetHash || state.iframeHash,
            };
        },
        setPageHash(state: IState, payload: string) {
            const pageHash = urlMapping[payload] ? urlMapping[payload] : payload;
            const targetHash = goPager(pageHash);
            return {
                ...state,
                ...state,
                pageHash: pageHash || state.pageHash,
                iframeHash: targetHash || state.iframeHash,
            };
        },
    },
    effects: () => ({}),
};

export default mainContent;
